var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6278 0 24 5.37225 24 12C24 18.6278 18.6278 24 12 24C5.37225 24 0 18.6278 0 12C0 5.37225 5.37225 0 12 0ZM13.875 15.984H10.125L12 19.6875L13.875 15.984ZM12.48 4.6875H11.52C11.2762 4.6875 11.2072 4.83 11.097 5.0235L5.682 16.6815C5.5275 17.013 5.703 17.0947 6.02025 17.0947L8.235 17.094C8.47875 17.094 8.5365 16.9087 8.6475 16.6807L12 9.561L15.3525 16.6807C15.4635 16.9087 15.5213 17.0933 15.765 17.0933L17.9797 17.0947C18.297 17.0947 18.4725 17.013 18.318 16.6823L12.903 5.0235C12.792 4.83 12.7237 4.6875 12.48 4.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlas);
export default __webpack_public_path__ + "static/media/Atlas.cb782272bad7761944d5a286d3e0a685.svg";
export { ForwardRef as ReactComponent };